// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3IJgd","description":"PatientConsentPreview_description__2_-cr"};